import { ColProps } from 'antd';
import { Gutter } from 'antd/lib/grid/row';

/**
 * Properties for an `antd` Column component
 * 
 * Fill half of the available space in the current row
 */
export const halfCol: ColProps = { span: 24, xl: 12 };
export const oneThirdCol: ColProps = { span: 24, xl: 8 };
export const twoThirdCol: ColProps = { span: 24, xl: 16 };
export const oneSixthCol: ColProps = { span: 24, xl: 4 };
export const ROW_GUTTER: [Gutter, Gutter] = [24, 24];
